/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { computed, ref, unref } from "common/vue/reactivity";

export function generateTiersObject(tiers: any) {
  return (
    tiers
      ?.toSorted((a: any, b: any) => a.min - b.min)
      // eslint-disable-next-line max-params
      .reduce((acc: any, current: any, i: any, array: any) => {
        const next = i < array.length - 1 ? array[i + 1] : null;
        if (next) {
          acc.push({
            range: `$${current.min} - $${(next.min - 0.01).toFixed(2)}`,
            min: current.min,
            max: next.min - 0.01,
            percentage: current.rate * 100
          });
        } else {
          acc.push({
            range: `Above $${current.min}`,
            min: current.min,
            max: Number.MAX_SAFE_INTEGER,
            percentage: current.rate * 100
          });
        }
        return acc;
      }, [])
  );
}

export default function useTransfersStoreCredit() {
  const storeCreditInfo = ref(null);

  const creditAmount = computed(() =>
    // @ts-expect-error TS(2339): Property 'userStoreCredits' does not exist on type... Remove this comment to see the full error message
    Number(storeCreditInfo.value?.userStoreCredits?.transfers?.totalAmount ?? 0)
  );

  // @ts-expect-error TS(2339): Property 'orderSubtotal' does not exist on type 'n... Remove this comment to see the full error message
  const orderSubtotal = computed(() => Number(storeCreditInfo.value?.orderSubtotal ?? 0));

  // @ts-expect-error TS(2339): Property 'expectedCredits' does not exist on type ... Remove this comment to see the full error message
  const expectedCredits = computed(() => Number(storeCreditInfo.value?.expectedCredits ?? 0));

  const transfersCartSubtotal = computed(() =>
    // @ts-expect-error TS(2339): Property 'transfersCartSubtotal' does not exist on... Remove this comment to see the full error message
    Number(storeCreditInfo.value?.transfersCartSubtotal ?? 0)
  );

  // @ts-expect-error TS(2339): Property 'tiers' does not exist on type 'never'.
  const tiers = computed(() => generateTiersObject(storeCreditInfo.value?.tiers ?? []));

  const totalCartAmount = computed(() => orderSubtotal.value + transfersCartSubtotal.value);

  const currentTier = computed(() => {
    if (!unref(tiers)?.length) return null;
    const lastTier = unref(tiers)[unref(tiers).length - 1];
    return unref(tiers).find((tier: any) => totalCartAmount.value <= tier.max) || lastTier;
  });

  const currentExpectedCredits = computed(() => {
    let total = 0;
    if (currentTier.value) {
      const multiplier = currentTier.value.percentage / 100;
      total = totalCartAmount.value * multiplier;
    }
    return total;
  });

  const updateStoreCreditInfo = (newInfo: any) => {
    storeCreditInfo.value = newInfo;
  };

  return {
    storeCreditInfo,
    creditAmount,
    orderSubtotal,
    expectedCredits,
    transfersCartSubtotal,
    tiers,
    totalCartAmount,
    currentTier,
    currentExpectedCredits,
    updateStoreCreditInfo
  };
}
